import { directions, orbitLimits } from '@inter-ikea-storageone/range';

const getCameraConfig = (widgetId: string) => {
  let direction = directions.FRONT_ANGLED_ABOVE_RIGHT_SMALL;
  let limits = orbitLimits.FRONT_ANGLED;

  switch (widgetId) {
    case 'frame-product-list':
      direction = directions.FRONT_ANGLED_ABOVE_SMALL;
      limits = orbitLimits.FRONT_UPPER;
      break;
    case 'legs-product-list':
      direction = directions.FRONT;
      limits = orbitLimits.FRONT;
      break;
    default:
      direction = directions.FRONT_ANGLED_ABOVE_RIGHT_SMALL;
      limits = orbitLimits.FRONT_UPPER;
      break;
  }
  return { direction, orbitLimits: limits };
};

export default getCameraConfig;
